/**
 * This code was generated by Builder.io.
 */
import styles from "./PaymentMethods.module.css";
import discover_logo from "../../assets/images/discover_logo.png";

function PaymentMethods() {
    return (
        <section className={styles.paymentContainer}>
            <h2 className={`${styles.paymentHeading}`}>Payment Methods</h2>
            <div className={styles.paymentLogos}>
                <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/55ef2533ceec28c6cd0e2326c9b97a6723e956030434574895661e8d00d0600f?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                    className={styles.paymentLogo}
                    alt="Mastercard"
                />
                <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/e883293e2dfbe99232b327c7d0188ec7a63428ba9055bfb4576837ab33057ffd?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                    className={styles.paymentLogo}
                    alt="Visa"
                />

                <img loading="lazy" src={discover_logo} className={styles.paymentLogo} alt="Discover" />
            </div>
        </section>
    );
}

export default PaymentMethods;
